import { IModelEntity } from '@pit/core';
import { IDtoShipmentProcess } from './dto.shipment.process.interface';

export interface IDtoShipmentList extends IModelEntity {

    depotNumber?: string;
    deviceId?: string;
    deviceIsAssigned?: boolean;
    externalShipmentId?: string;
    shipmentDate?: Date;
    shipmentNumbers?: string[];

    productTypeCode?: string;
    productTypeDescription?: string;

    userDescription?: string;
    userName?: string;

    currentProcess?: IDtoShipmentProcess;

    isFinished?: boolean;
    isOpen?: boolean;
    processStateDescription?: string;

    getHasShipmentNumber?: (shipmentNumber: string) => boolean;

}
